// extracted by mini-css-extract-plugin
export default {"container":"ConfirmationRemoveCart-container_NWcyK","containerButton":"ConfirmationRemoveCart-containerButton_iuvZs"};